import { __awaiter, __generator } from "tslib";
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { httpGet } from '@office-start/xhr-service';
import { getGraphServiceEndpoint } from '../utilities/getGraphServiceEndpoint';
//TODO: mock mode, instrumentation
export function fetchPeoplePicture(_a) {
    var correlationId = _a.correlationId, jwtAuthEnabled = _a.jwtAuthEnabled, getAccessToken = _a.getAccessToken, graphApiRoot = _a.graphApiRoot, officeApiRoot = _a.officeApiRoot, pictureId = _a.pictureId, size = _a.size;
    return __awaiter(this, void 0, void 0, function () {
        var requestConfig, apiPath, url, reader, getPicture;
        return __generator(this, function (_b) {
            requestConfig = {
                method: "GET" /* HttpRequestMethod.Get */,
                responseType: "blob" /* HttpResponseContentType.Blob */,
            };
            if (!pictureId) {
                return [2 /*return*/, undefined];
            }
            apiPath = size === undefined
                ? "users/".concat(pictureId, "/photo/$value")
                : "users/".concat(pictureId, "/photos/").concat(size, "/$value");
            url = getGraphServiceEndpoint(graphApiRoot, apiPath);
            reader = new FileReader();
            getPicture = new Promise(function (resolve) {
                httpGet(KnownInstrumentationEvents.OneDriveGraphPeoplePictureRequest, "OneDrive_Graph_People_Picture" /* KnownRequestInstrumentationEvents.OneDriveGraphPeoplePictureRequest */, url, requestConfig, jwtAuthEnabled, getAccessToken, officeApiRoot, correlationId, 'Graph')
                    .then(function (response) {
                    if (response && response.ok && response.data) {
                        reader.onloadend = function () {
                            var result = (reader.result &&
                                typeof reader.result === 'string' &&
                                reader.result.split(',')) ||
                                [];
                            if (result.length > 1) {
                                resolve(result[1]);
                            }
                            else {
                                resolve(undefined);
                            }
                        };
                        reader.onerror = function () { return resolve(undefined); };
                        reader.onabort = function () { return resolve(undefined); };
                        reader.readAsDataURL(response.data);
                    }
                    else {
                        resolve(undefined);
                    }
                })
                    .catch(function () {
                    //TODO: error handling
                    resolve(undefined);
                });
            });
            return [2 /*return*/, getPicture];
        });
    });
}
//# sourceMappingURL=fetchPeoplePicture.js.map